import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-biens-particuliers',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-biens-particuliers.component.html',
  styleUrls: ['./assurance-biens-particuliers.component.scss']
})
export class AssuranceBiensParticuliersComponent {
  title = 'Assurance des Biens pour Particuliers';
  subtitle = '';
  heroImage = 'assets/static_pages_images/La chambre de Van Gogh à Arles.jpg';

  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance des Biens', link: undefined }
  ];

  prevPage = { title: 'Assurance des Personnes pour Professionnels et Entreprises',
    link: '/assurance-personnes-professionnels'
  };

  nextPage = { title: 'Assurance des Biens pour Professionnels et Entreprises',
    link: '/assurance-biens-professionnels'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

